(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-editable-note"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ff-note-music')) {
    customElements.define('ff-note-music', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.audio = this.querySelector('audio');
        const button = this.querySelector('button');
        if (!this.audio || !button) return;
        this.audio.volume = Math.max(0, Math.min(1, Number(this.dataset.volume) / 100));
        this.audio.controls = false;
        this.audio.hidden = true;
        button.hidden = false;
        const update = () => {
          const playing = !this.audio.paused;
          button.setAttribute('aria-pressed', String(playing));
          button.setAttribute('aria-label', playing ? 'Pause ambient music' : 'Play ambient music');
          this.querySelector('[data-note-play]').hidden = playing;
          this.querySelector('[data-note-pause]').hidden = !playing;
        };
        const fallback = () => {
          button.hidden = true;
          this.audio.hidden = false;
          this.audio.controls = true;
        };
        button.addEventListener('click', () => {
          if (this.audio.paused) this.audio.play().catch(fallback);
          else this.audio.pause();
        }, options);
        this.audio.addEventListener('play', update, options);
        this.audio.addEventListener('pause', update, options);
        this.audio.addEventListener('error', fallback, options);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.audio?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch') return;
    const link = event.target.closest('.ffft-col a');
    if (!link || link.contains(event.relatedTarget)) return;
    const previousColor = link.style.getPropertyValue('--ffft-link-hover');
    link.style.setProperty('--ffft-link-hover', previousColor === '#ef94ff' ? '#b3f5ee' : '#ef94ff');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu, ff-menu-panel');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
